// extracted by css-extract-rspack-plugin
export default {"transactionInfo":"transactionInfo-IE9lIi","number":"number-KnLTOq","DetailsRow":"DetailsRow-lUPD_o","detailsRow":"DetailsRow-lUPD_o"};